import { render, staticRenderFns } from "./TeacherCategoryImport.vue?vue&type=template&id=343b9ba8&scoped=true"
import script from "./TeacherCategoryImport.vue?vue&type=script&lang=js"
export * from "./TeacherCategoryImport.vue?vue&type=script&lang=js"
import style0 from "./TeacherCategoryImport.vue?vue&type=style&index=0&id=343b9ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343b9ba8",
  null
  
)

export default component.exports